import { render, staticRenderFns } from "./GroupWidget.vue?vue&type=template&id=7319a91b"
import script from "./GroupWidget.vue?vue&type=script&lang=js"
export * from "./GroupWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports